import { Box, Typography } from '@mui/material'
import { CheckType } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { RenderIsoCodeMappingInputFn } from '@planning/pages/Order/stores/IsoCodeMappingInputStore'
import { useTranslate } from '@tolgee/react'
import { BackButton, ContainerMobile, Header, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { TallymanV2ViewStore } from '../../../../rt-stores/tallyman/TallymanV2ViewStore'
import { SelectCarrierAndOperation } from '../../SelectCarrierAndOperation'
import { HeaderAvatar } from '../HeaderComponents/HeaderAvatar'
import { VesselVisitOperation } from '../VesselSelectionStepper'

interface IProps {
  store: TallymanV2ViewStore
  onSelectVesselOperation: (op: VesselVisitOperation) => void
  onSelectTrainOperation: (op: CheckType) => void
  onVesselSelection: (id: number) => void
  onCraneSelection: (id: number) => void
  renderIsoCodeMappingInput?: RenderIsoCodeMappingInputFn
}

export const WorkAssignmentsSelection: FC<IProps> = observer(
  ({
    store,
    onSelectVesselOperation,
    onSelectTrainOperation,
    onVesselSelection,
    onCraneSelection,
    renderIsoCodeMappingInput,
  }) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()
    const { tenantStore, drawerStore, isoCodeMappingInputStore } = usePlanningStore()
    const title =
      t('tallyClerk', 'Tally clerk') +
      (store.selectedGang?.name ? ` - ${store.selectedGang.name}` : '')
    const skipRailTally = tenantStore.skipRailTally
    const skipVesselTally = tenantStore.skipVesselTally

    if (!store.railTallyStore || !store.vesselTallyStore) return <></>

    store.preselectTrainType(skipRailTally, skipVesselTally)

    isoCodeMappingInputStore.renderIsoCodeMappingInput = renderIsoCodeMappingInput

    return (
      <Box
        style={{
          backgroundColor: theme.palette.grey[200],
          minHeight: 'calc(100vh - 65px)',
        }}
      >
        <Header
          title={title}
          rightRenderOption={
            drawerStore.open ? (
              <BackButton onGoBack={drawerStore.close} tooltip={t('return', 'Return')} />
            ) : (
              <HeaderAvatar />
            )
          }
        />
        <ContainerMobile
          sx={{
            backgroundColor: theme.palette.grey[200],
            pt: theme.customSpacing.l,
            height: '100vh',
          }}
        >
          <Typography variant='h6' gutterBottom>
            {t('workAssignments', 'Work assignments')}
          </Typography>
          <SelectCarrierAndOperation
            store={store}
            selectedCarrierType={store.selectedCarrierType}
            onSelectVesselOperation={onSelectVesselOperation}
            onSelectTrainOperation={onSelectTrainOperation}
            onVesselSelection={onVesselSelection}
            onCraneSelection={onCraneSelection}
          />
        </ContainerMobile>
      </Box>
    )
  },
)
